import { usePriceAndChange } from "@/App/Equities/shared/services/marketData"
import {
  formatCurrency,
  formatPercentageSigned,
} from "@/App/Equities/shared/utils"
import { Typography } from "@/generated/material"

interface ValueProps {
  symbol: string
}

export const CurrentPriceValue = ({ symbol }: ValueProps) => {
  const { price } = usePriceAndChange(symbol)
  return formatCurrency(price)
}

export const ChangePercentage = ({ symbol }: ValueProps) => {
  const { change, changeAmount } = usePriceAndChange(symbol)
  return (
    <Typography
      variant="Text md/Regular"
      color={changeAmount < 0 ? "negative" : "positive"}
    >
      {formatPercentageSigned(change)}
    </Typography>
  )
}

export const ChangeAmount = ({ symbol }: ValueProps) => {
  const { changeAmount } = usePriceAndChange(symbol)
  return (
    <Typography
      variant="Text md/Regular"
      color={changeAmount < 0 ? "negative" : "positive"}
    >
      {formatCurrency(changeAmount)}
    </Typography>
  )
}
